<!-- 凭证预览 -->
<template>
  <div id="voucher" class="common-secondary-page">
    <!-- 通用二级页面头部 -->
    <div class="common-header">
      <van-nav-bar
        title="凭证预览"
        left-arrow
        :border="false"
        @click-left="onClickLeft"
      />
      <div class="rounder" />
    </div>
    <!-- 通用二级页面内容 -->
    <div class="content-container">
      <div class="mobile-view">
        <div class="recipe-view" @click="viewImg()">
          <div ref="orderForm" class="recipe-container">
            <div class="title">安阳学院收据</div>
            <div class="secondary-title-row">
              <div class="block left">
                <div class="left">缴费日期：</div>
                <div class="value-red">{{ recipeInfo.tradeTime }}</div>
              </div>
              <div class="block left">
                <div class="left-label">支付方式：</div>
                <div class="value">{{ recipeInfo.tradeChannel }}</div>
              </div>
              <div class="block right">
                <div class="label">收据编号：</div>
                <div class="value">
                  {{ recipeInfo.orderNo }}
                </div>
              </div>
            </div>
            <div class="tab_company_out">
              <table class="tab_company_out_table1" cellpadding="0" cellspacing="0">
                <tr>
                  <th width="15%">
                    <p>姓名：{{ recipeInfo.bizUserName }}</p>
                    <p>学号：{{ recipeInfo.idserial }}</p>
                  </th>
                  <th width="15%">
                    <p>班级：{{ recipeInfo.bizDepName }}</p>
                    <p>收费年度：{{ recipeInfo.tradeYear }}</p>
                  </th>
                </tr>
                <tr>
                  <td width="15%" style="font-weight: bolder">项目名称</td>
                  <td width="15%" style="font-weight: bolder">金额（元）</td>
                </tr>
                <tr v-for="d in recipeInfo.payBizDetailList" :key="`_${d}_`">
                  <td>{{ d.detailName }}</td>
                  <td>{{ fenToYuan(d.standardAmount) }}</td>
                </tr>
                <tr v-for="d in recipeInfo.fillList" :key="`_${d}_`">
                  <td> </td>
                  <td> </td>
                </tr>
                <tr>
                  <th>合计：{{ computeLen1(fenToYuan(recipeInfo.amount)) }}</th>
                  <th>合计：¥{{ fenToYuan(recipeInfo.amount) }}</th>
                </tr>
              </table>
            </div>
            <div class="secondary-title-rowend">
              <div class="block left"></div>
              <div class="block right">
                <div class="right-label">收费单位：安阳学院</div>
                <!-- <div class="value"> {{ recipeInfo.schoolName }}</div>
                <div class="value">安阳学院</div> -->
              </div>
            </div>
            <img src="../../assets/printLogo.png" class="seal">
          </div>
        </div>
      </div>
    </div>
    <!-- <van-button
      v-if="!wechatFlag"
      size="large"
      type="info"
      icon="description"
      style="margin:30px 12px;width:calc(100% - 24px)"
      @click="downloadPDF"
    >
      保存PDF
    </van-button> -->
    <div @click="viewImg()">
      <span class="notice">点击放大后可保存图片</span></div>
  </div>
</template>
<script>
// import store from '@/store'

import { fenToYuan } from '@/utils/commonUtils'
import { ImagePreview } from 'vant'
import { queryOrderbyNo } from '@/api/orderTrade'
import JsPDF from 'jspdf'
import html2canvas from 'html2canvas'
export default {
  name: 'OrderDetail',
  components: {
    // ReiTabbar
  },
  data() {
    return {
      wechatFlag: true,
      fineReportUrl: '',
      tempData: {
        displayStatus: '',
        status: '',
        payBizInfoVOList: [],
        id: '',
        projectId: {}
      },
      schoolName: '',
      showType: '',
      rightDataList: [],
      detailList: [],
      shopList: [{}],
      recipeInfo: {
        idserial: '',
        orderNo: this.$route.query.orderNo,
        tradeTime: '',
        tradeYear: '',
        bizDepName: '',
        bizUserName: '',
        bizdepName: '',
        projectName: '',
        payBizDetailList: [],
        fillList: [],
        user: '',
        year: '',
        month: '',
        day: '',
        sumAmt: '',
        kpr: '',
        skr: '',
        billNo: '',
        itemPro: ''
      },
      // 支付方式
      channelList: [],
      order: {},
      activeNames: ['1'],
      imageL: [require('../../assets/newImages/line.png')]
    }
  },
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'background: #F5F5F5')
  },

  mounted() {
    this.queryOrderbyNo()
    this.isWechat()
  },
  methods: {
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') !== -1) {
        this.wechatFlag = true
      } else {
        this.wechatFlag = false
      }
      return
    },
    fenToYuan(obj) {
      if (obj === null || obj === 0) {
        return '0'
      }
      return fenToYuan(obj)
    },
    queryOrderbyNo() {
      queryOrderbyNo(this.$route.query.orderNo).then((response) => {
        this.recipeInfo.schoolName = response.data.schoolName
        this.recipeInfo.projectName = response.data.projectName
        this.recipeInfo.bizUserName = response.data.bizUserName
        this.recipeInfo.bizDepName = response.data.bizDepName
        this.recipeInfo.amount = response.data.amount
        this.recipeInfo.idserial = response.data.bizUserNo
        this.recipeInfo.tradeChannel = response.data.tradeChannel
        this.recipeInfo.tradeTime = response.data.tradeTime
        this.recipeInfo.tradeYear = response.data.schoolYear
        this.recipeInfo.payBizDetailList = response.data.payBizDetailVOS
        for (var i = 0; i < 4 - this.recipeInfo.payBizDetailList.length; i++) {
          this.recipeInfo.fillList[i] = {}
        }
      })
    },
    // 调用vant组件实现缩放查看大图
    viewImg() {
      const myBox = this.$refs.orderForm // 获取ref里面的内容
      html2canvas(myBox, {
        useCORS: true, // 是否尝试使用CORS从服务器加载图像
        allowTaint: true,
        dpi: 300, // 解决生产图片模糊
        scale: 3 // 清晰度--放大倍数
      }).then(function(canvas) {
        const pageData = canvas.toDataURL('image/jpeg', 1.0)
        const imgList = []
        imgList.push(pageData)
        ImagePreview({
          images: imgList,
          closeable: true,
          showIndex: false
        })
      })
    },
    downloadPDF() {
      var orderNo = this.recipeInfo.orderNo
      const PDF = new JsPDF('', 'pt', 'a4')

      const myBox = this.$refs.orderForm // 获取ref里面的内容
      html2canvas(myBox, {
        useCORS: true, // 是否尝试使用CORS从服务器加载图像
        allowTaint: true,
        dpi: 300, // 解决生产图片模糊
        scale: 3 // 清晰度--放大倍数
      }).then(function(canvas) {
        const contentWidth = canvas.width
        const contentHeight = canvas.height
        const pageHeight = (contentWidth / 592.28) * 841.89 // 一页pdf显示html页面生成的canvas高度;
        let leftHeight = contentHeight // 未生成pdf的html页面高度
        let position = 0 // pdf页面偏移
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        // let imgWidth = 595.28
        const imgWidth = 560.28 // 宽度
        const imgHeight = (592.28 / contentWidth) * contentHeight
        const pageData = canvas.toDataURL('image/jpeg', 1.0)

        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 20, 255, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(orderNo + '.pdf') // 下载标题
      })
    },
    computeLen1(number) {
      let ret = ''
      if (number !== '' && number != null && number !== '0') {
        let unit = '仟佰拾亿仟佰拾万仟佰拾元角分'
        let str = ''
        number += '00'
        const point = number.indexOf('.')
        if (point >= 0) {
          number = number.substring(0, point) + number.substr(point + 1, 2)
        }
        unit = unit.substr(unit.length - number.length)
        for (let i = 0; i < number.length; i++) {
          str +=
            '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i)
        }
        ret =
          str
            .replace(/零(仟|佰|拾|角)/g, '零')
            .replace(/(零)+/g, '零')
            .replace(/零(万|亿|元)/g, '$1')
            .replace(/(亿)万|(拾)/g, '$1$2')
            .replace(/^元零?|零分/g, '')
            .replace(/元$/g, '元') + '整'
      }
      return ret
    },
    recipeInfoClick(item) {
      console.log(item)
      this.showRecipe = true
      this.recipeInfo = item
    },
    init() {
      this.queryOrderbyNo()

      // store.dispatch('user/getInfo').then(res => { // 拉取user_info
      //   this.user.name = res.name
      //   this.user.idserial = res.idserial
      //   this.getList()
      //   this.queryDetail()
      // }).catch((err) => {
      //   console.log(err)
      //   store.dispatch('user/logout').then(() => {
      //     location.reload() // 为了重新实例化vue-router对象 避免bug
      //   })
      // })
    },

    // 返回
    onClickLeft() {
      this.$router.push({ path: '/orderList' })
    }
  }
}
</script>
<style lang="scss" scoped>
//通用二级页面（带NavBar的）引这个
@import "../../assets/common_secondary.scss";

#voucher {
  .content-container {
    padding-left: 12px;
    padding-right: 12px;
  }
  .recipe-view {
    width: 100%;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 8px;
    background: #fff;
    // .print-logo{
    //     float: right;
    //     z-index: 2;
    //     width: 150px;
    //     margin-top: -160px;
    //     margin-right: -10px;
    // }
    .recipe-container {
      width: 100%;
      color: black;
      box-sizing: border-box;
      padding: 8px;
      .title {
        margin-top: 2px;
        width: 100%;
        height: 18px;
        line-height: 18px;
        font-size: 15px;
        font-weight: bold;
        text-align: center;
        font-family: "SimSun", "STSong", "Songti SC", "宋体", sans-serif;
      }
      .secondary-title-row {
        width: 98%;
        margin-top: 10px;
        height: 10px;
        line-height: 10px;
        padding: 10px 1px  10px  1px;
        font-size: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .block {
          display: flex;
          align-items: center;
          .value-red {
            // color: #d70c15;
          }
        }
      }
    .secondary-title-rowend {
      width: 100%;
      height: 32px;
      display: flex;
      font-size: 9px;
      align-items: left;
      .block {
        display: flex;
        align-items: left ;
        &.left {
          width: 50%;
        }
        &.right {
          width: 50%;
        }
        .left-label {
          width: 70px;
          text-align: right;
        }
        .right-label {
          width: 100px;
          text-align: center;
        }
      }
    }
      .detail-box {
      width: 100%;
      height: 110px;
      border: 1px solid #c0c4cc;
      margin: 4px 0;
      box-sizing: border-box;
      padding: 5px;
      font-size: 8px;
      .top-row {
        width: 100%;
        display: flex;
        gap: 10px;
        .left-label {
          width: 40px;
          flex-shrink: 0;
          text-align: right;
          padding: 8px 0;
        }
        .info-box {
          flex-grow: 1;
          .info-row {
            width: 97%;
            border-bottom: 1px solid #c0c4cc;
            padding: 8px 0;
          }
        }
      }
      .bottom-row {
        width: 100%;
        display: flex;
        margin-top: 20px;
        .block {
          display: flex;
          align-items: center;
          gap: 10px;
          &.left {
            width: 45%;
          }
          &.right {
            width: 55%;
          }
          .left-label {
            width: 55px;
            flex-shrink: 0;
            text-align: left;
            padding: 8px 0;
          }
          .right-label {
            width: 40px;
            text-align: right;
          }
          .info-row {
            width: 80%;
            border-bottom: 1px solid #c0c4cc;
            padding: 8px 0;
          }
          .info-row1 {
            width: 57%;
            border-bottom: 1px solid #c0c4cc;
            padding: 8px 0;
          }
        }
      }
      }
      .table-box {
        width: 100%;
        border: 1px solid #c0c4cc;
          font-size: 9px;
        margin-top: 4px;
        .line-b {
          border-bottom: 1px solid #c0c4cc;
        }
        .line-r {
          border-right: 1px solid #c0c4cc;
        }
        .top-row {
          font-size: 10px;
          height: 24px;
          line-height: 24px;
          display: flex;
          .label {
            text-align: center;
            width: 16%;
          }
          .value {
            padding: 0 2%;
          }
        }
        .detail-th-row {
          display: flex;
          font-size: 10px;
          height: 18px;
          line-height: 18px;
          .label {
            width: 38%;
            text-align: center;
          }
          .value {
            width: 38%;
            text-align: center;
          }
          .note {
            width: 24%;
            text-align: center;
          }
        }
        .detail-box {
          display: flex;
          font-size: 9px;
          .detail-col {
            width: 76%;
            .detail-row {
              display: flex;
              height: 16px;
              line-height: 16px;
              .label {
                width: 50%;
                text-align: center;
              }
              .value {
                width: 50%;
                text-align: center;
              }
            }
            .sum-row {
              display: flex;
              height: 20px;
              line-height: 20px;
              font-size: 10px;
              .label {
                width: 21.1%;
                text-align: center;
                flex-shrink: 0;
              }
              .value {
                display: flex;
                flex-grow: 1;
                padding: 0 2.6%;
                justify-content: space-between;
              }
            }
          }
          .note-col {
            width: 24%;
          }
        }
      }
      .bottom-row {
        width: 100%;
        display: flex;
        margin-top: 6px;
        height: 12px;
        line-height: 12px;
        justify-content: space-between;
        font-size: 8px;
      }
      .seal {
        width: 18%;
        position: absolute;
        margin-top: -15%;
        margin-left: 60%;
        opacity: 1;
        z-index: 1;
      }
    }
  }
}
.notice{
      margin-left: 10%;
      font-size: 12px;
      color: red;
}
.tab_company_out {
  text-align: center;
  width: 100%;
  margin-top: 1px;
  margin-bottom: 1px
}
.tab_company_out table {
  width: 100%;
  border: 1px solid #514f4f;
  border-bottom: 1px solid #514f4f;
}

.tab_company_out_table1 tr th {
  border-top: 1px solid #514f4f;
  border-left: 1px solid #514f4f;
  border-right: 1px solid #514f4f;
  border-bottom: 1px solid #514f4f;
  height: 30px;
  line-height: 15px;
  padding: 5px;
  font-size: 8px;
  text-align: left;
  color: black;
}

.tab_company_out_table1 tr td {
  border-top: 1px solid #514f4f;
  border-left: 1px solid #514f4f;
  border-right: 1px solid #514f4f;
  border-bottom: 1px solid #514f4f;
  height: 20px;
  line-height: 15px;
  font-size: 8px;
  text-align: center;
  color: black;
}

.tab_company_out tr td:last-of-type,
.tab_company_out tr th:last-of-type {
  border-right: 1px solid #514f4f;
}

.tab_company_out .count-top {
  border-top:none;
  text-align: center;
}

.tab_company_out .count-top span {
  line-height: 20px;
  font-size: 12px;
  color:black;
}
</style>
